import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";

@Injectable({
  providedIn: "root",
})
export class ContextMenuService {
  statusMenu$: Subject<boolean> = new Subject<boolean>();
}
